import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {Helmet} from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import AboutUs from "../aboutus";
import Faqs from "../faqs";
import Portfolios from "../portfolios";
import Features from "../features";
import Pricing from "../pricing";
import Services from "../services";
import Teams from "../teams";
import Testimonials from "../testimonials";
import Clients from "../clients";
import Certificate from "../Certificate";
import Contact from "../contact";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What certifications has Pankaj Singh received?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Pankaj Singh has received certifications from BSNL, Computer Society of India (CSI), S&N Hayakawa Japan, and Ericsson for achievements like Industrial Visits, Personal Effectiveness, Japanese Language, and Tools Development."
      }
    },
    {
      "@type": "Question",
      "name": "What is the BSNL Industrial Visit certificate?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It certifies participation in an industrial visit to Bharat Sanchar Nigam Ltd (BSNL) on 2nd September 2011 to understand telecom operations and infrastructure."
      }
    },
    {
      "@type": "Question",
      "name": "What does the CSI Personal Effectiveness certificate cover?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "This certificate, awarded by the Computer Society of India on 16th July 2011, focuses on communication, productivity, and soft skill enhancement for professionals."
      }
    },
    {
      "@type": "Question",
      "name": "Where did you learn Japanese language?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I studied Japanese at S&N Hayakawa, Japan, and received a certificate for language proficiency between 2009 and 2013."
      }
    },
    {
      "@type": "Question",
      "name": "What is the Ericsson Tools Development certificate?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It acknowledges my contribution to internal tools and process automation at Ericsson India Pvt. Ltd. in 2016."
      }
    },
    {
      "@type": "Question",
      "name": "Are these certificates verifiable?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all certificates are publicly displayed on my website for authenticity and transparency."
      }
    },
    {
      "@type": "Question",
      "name": "Do these certifications relate to web development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. They showcase both technical and soft skills that are crucial in delivering high-quality, user-focused web solutions."
      }
    },
    {
      "@type": "Question",
      "name": "Are the certificates from reputed institutions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. BSNL, Ericsson, CSI, and Hayakawa are recognized organizations with strong industry credibility."
      }
    },
    {
      "@type": "Question",
      "name": "What skills are covered in these certificates?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Skills include personal communication, software tools, language proficiency, teamwork, and real-world telecom and IT exposure."
      }
    },
    {
      "@type": "Question",
      "name": "Why is Japanese language certification useful in web development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It helps me communicate effectively with Japanese clients, understand localization needs, and support global projects."
      }
    },
    {
      "@type": "Question",
      "name": "Do you keep updating your skillset with new certifications?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I actively pursue learning and upgrade my skills regularly to stay relevant in the fast-evolving digital industry."
      }
    },
    {
      "@type": "Question",
      "name": "How do your certifications help clients?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "They reassure clients that I have both technical expertise and real-world experience to deliver successful projects."
      }
    },
    {
      "@type": "Question",
      "name": "Is your Ericsson certificate specific to programming?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, it involved automation and tools development work, which aligns closely with my front-end and web app development experience."
      }
    },
    {
      "@type": "Question",
      "name": "What does the BSNL certificate add to your resume?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It reflects practical exposure to large-scale telecom systems, useful in understanding server architecture and uptime requirements."
      }
    },
    {
      "@type": "Question",
      "name": "Can I download or view your certificates?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all certificates are displayed on my website’s certificate page with clear visuals for review."
      }
    },
    {
      "@type": "Question",
      "name": "Do these certificates improve your SEO or marketing skills?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, especially the personal effectiveness training helped in clear messaging, client communication, and persuasive design."
      }
    },
    {
      "@type": "Question",
      "name": "Do you plan to pursue more certifications in the future?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I believe in lifelong learning and plan to take courses in AI, advanced JS frameworks, and digital marketing."
      }
    },
    {
      "@type": "Question",
      "name": "Are any of these certificates related to SEO?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "While none are SEO-specific, the skills learned in communication and tool development directly help implement SEO strategies effectively."
      }
    },
    {
      "@type": "Question",
      "name": "How do your certificates make you different from other freelancers?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "They prove I’ve worked in structured corporate environments and have practical skills that go beyond just design—into strategy, tools, and language."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer training or mentorship related to these skills?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I occasionally mentor junior developers and guide them on certifications, project planning, and freelance strategy."
      }
    },
    {
      "@type": "Question",
      "name": "Can I mention your certifications in my project proposal?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, feel free to highlight my certifications when presenting my profile in your team or client meetings."
      }
    },
    {
      "@type": "Question",
      "name": "Where can I see your certification details?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can visit https://www.pankj.com/certificate to see high-quality images and details of each certificate I have earned."
      }
    }
  ]
}


function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
    <title>Certificate - Website Developer In Gurgaon</title>
  <meta name="description" content="website developer in gurgaon, delhi, noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India."/>
  <meta name="keywords" content="pankaj, pankj, web designers near me, website designer near me, web designing company in gurgaon, website developer in gurgaon, website development company in gurgaon,freelance web designer, web design gurgaon, website design gurgaon, web design companies near me, web design company, website design company"/>
<meta property="og:title" content="Certificate - website developer in gurgaon | website development company in gurgaon" />
<meta property="og:description" content="website developer in gurgaon, delhi, noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<meta property="og:site_name" content="Certificate - website developer in gurgaon | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/certificate"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Certificate - website developer in gurgaon | website development company in gurgaon" />
<meta name="twitter:description" content="website developer in gurgaon, delhi, noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<link rel="canonical" href="https://www.pankj.com/certificate" />

        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer6.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Certificate</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="Website Designer In Gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">
    <Certificate />
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
